<template lang="pug">
  span
    //- empty link in WP returns string
    a(v-if="!link || typeof link === 'string'", data-warn="missing link")
      slot
    //- external links
    a(v-else-if="isExt(link.url)", :href="link.url", :target="link.target", :rel="link.target === '_blank' && 'noopener'", :class="linkClss")
      slot
    //- internal links
    router-link(v-else, :to="resolve(link.url)", :class="linkClss")
      slot
</template>

<script>
import { linkResolver, isExtLink } from '@/utils'
export default {
  name: 'WPLink',
  props: {
    link: { type: [Object, String] },
    // link: { type: Object, default: () => { return { title: 'Missing Link', url: '/' } } },
    text: { type: String, default: null },
    linkClss: { type: String, default: '' }
  },
  data () {
    return {
      resolve: linkResolver,
      isExt: isExtLink
    }
  }
}
</script>

<style>
</style>
